import { render, staticRenderFns } from "./SvgTriangle.vue?vue&type=template&id=858bca1c&"
import script from "./SvgTriangle.vue?vue&type=script&lang=js&"
export * from "./SvgTriangle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('858bca1c')) {
      api.createRecord('858bca1c', component.options)
    } else {
      api.reload('858bca1c', component.options)
    }
    module.hot.accept("./SvgTriangle.vue?vue&type=template&id=858bca1c&", function () {
      api.rerender('858bca1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Shared/SvgTriangle.vue"
export default component.exports